import { SfdcDisplayType } from '../../../types/fields';
import { ApiSweepFieldOperator } from '../../SweepFieldsOperatorSelector/sweepFieldsTypesAndOperators';

const checkboxOperators = [
  ApiSweepFieldOperator.EQUALS,
  ApiSweepFieldOperator.IS_CHANGED,
  ApiSweepFieldOperator.IS_NULL,
];

const dateOperators = [
  ApiSweepFieldOperator.EQUALS,
  ApiSweepFieldOperator.NOT_EQUAL_TO,
  ApiSweepFieldOperator.IS_NULL,
  ApiSweepFieldOperator.LOWER_THAN,
  ApiSweepFieldOperator.BEFORE,
  ApiSweepFieldOperator.GREATER_THAN,
  ApiSweepFieldOperator.AFTER,
  ApiSweepFieldOperator.GREATER_OR_EQUAL,
  ApiSweepFieldOperator.LOWER_OR_EQUAL,
  ApiSweepFieldOperator.IS_CHANGED,
];

const dateTimeOperators = [
  ApiSweepFieldOperator.EQUALS,
  ApiSweepFieldOperator.NOT_EQUAL_TO,
  ApiSweepFieldOperator.IS_NULL,
  ApiSweepFieldOperator.LOWER_THAN,
  ApiSweepFieldOperator.BEFORE,
  ApiSweepFieldOperator.GREATER_THAN,
  ApiSweepFieldOperator.AFTER,
  ApiSweepFieldOperator.IS_CHANGED,
];

const timeOperators = [
  ApiSweepFieldOperator.EQUALS,
  ApiSweepFieldOperator.NOT_EQUAL_TO,
  ApiSweepFieldOperator.IS_NULL,
  ApiSweepFieldOperator.LOWER_THAN,
  ApiSweepFieldOperator.BEFORE,
  ApiSweepFieldOperator.GREATER_THAN,
  ApiSweepFieldOperator.AFTER,
  ApiSweepFieldOperator.GREATER_OR_EQUAL,
  ApiSweepFieldOperator.LOWER_OR_EQUAL,
  ApiSweepFieldOperator.IS_CHANGED,
];

const numberOperators = [
  ApiSweepFieldOperator.EQUALS,
  ApiSweepFieldOperator.NOT_EQUAL_TO,
  ApiSweepFieldOperator.IS_NULL,
  ApiSweepFieldOperator.LOWER_THAN,
  ApiSweepFieldOperator.BEFORE,
  ApiSweepFieldOperator.GREATER_THAN,
  ApiSweepFieldOperator.AFTER,
  ApiSweepFieldOperator.IS_CHANGED,
];
const currencyOperators = [
  ApiSweepFieldOperator.EQUALS,
  ApiSweepFieldOperator.NOT_EQUAL_TO,
  ApiSweepFieldOperator.IS_NULL,
  ApiSweepFieldOperator.LOWER_THAN,
  ApiSweepFieldOperator.LOWER_OR_EQUAL,
  ApiSweepFieldOperator.GREATER_THAN,
  ApiSweepFieldOperator.GREATER_OR_EQUAL,
  ApiSweepFieldOperator.IS_CHANGED,
];

const percentOperators = [
  ApiSweepFieldOperator.EQUALS,
  ApiSweepFieldOperator.NOT_EQUAL_TO,
  ApiSweepFieldOperator.IS_NULL,
  ApiSweepFieldOperator.LOWER_THAN,
  ApiSweepFieldOperator.BEFORE,
  ApiSweepFieldOperator.GREATER_THAN,
  ApiSweepFieldOperator.AFTER,
  ApiSweepFieldOperator.GREATER_OR_EQUAL,
  ApiSweepFieldOperator.LOWER_OR_EQUAL,
];

const textOperators = [
  ApiSweepFieldOperator.EQUALS,
  ApiSweepFieldOperator.NOT_EQUAL_TO,
  ApiSweepFieldOperator.IS_NULL,
  ApiSweepFieldOperator.IS_CHANGED,
  ApiSweepFieldOperator.STARTS_WITH,
  ApiSweepFieldOperator.ENDS_WITH,
];

export const allowedOperatorsByType: Record<SfdcDisplayType, ApiSweepFieldOperator[]> = {
  [SfdcDisplayType.BOOLEAN]: checkboxOperators,
  [SfdcDisplayType.COMBOBOX]: textOperators,
  [SfdcDisplayType.DATE]: dateOperators,
  [SfdcDisplayType.DATETIME]: dateTimeOperators,
  [SfdcDisplayType.TIME]: timeOperators,
  [SfdcDisplayType.CURRENCY]: currencyOperators,
  [SfdcDisplayType.NUMBER]: numberOperators,

  [SfdcDisplayType.PERCENT]: percentOperators,
  [SfdcDisplayType.MULTIPICKLIST]: textOperators,
  [SfdcDisplayType.PICKLIST]: textOperators,
  [SfdcDisplayType.EMAIL]: textOperators,
  [SfdcDisplayType.ENCRYPTEDSTRING]: textOperators,
  [SfdcDisplayType.LONGTEXTAREA]: textOperators,
  [SfdcDisplayType.PHONE]: textOperators,
  [SfdcDisplayType.URL]: textOperators,
  [SfdcDisplayType.TEXTAREA]: textOperators,
  [SfdcDisplayType.STRING]: textOperators,

  [SfdcDisplayType.REFERENCE]: textOperators,
  [SfdcDisplayType.ID]: textOperators,

  [SfdcDisplayType.ADDRESS]: [], // Not supported in Flows
  [SfdcDisplayType.GEOLOCATION]: numberOperators,

  [SfdcDisplayType.INTEGER]: numberOperators,
  [SfdcDisplayType.DOUBLE]: numberOperators,
  [SfdcDisplayType.UNKNOWN]: [],
};
